import {
  attachCustomsInfoSelector,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {FEDEX} from '../../../common/constants/ShipperNames.js'
import {getState, useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const VALID_SHIPPER_TYPES = [FEDEX]

const B13A_FILING_OPTION_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return B13A_FILING_OPTION_DEPENDENT_PROPERTIES
}

export function formatB13AFilingOptionLabelProperty(shipperType) {
  return `${shipperType}__b13a_filing_option`
}

export function b13AFilingOptionLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo
    ? [formatB13AFilingOptionLabelProperty(shipperType)]
    : []
}

const VALID_B1A_FILING_OPTION_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map(
  (shipperType) => formatB13AFilingOptionLabelProperty(shipperType),
)

export default function B13AFilingOption() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = B13AFilingOption.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="B13A Filing Option"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="b13a_filing_option"
      hide={!attachCustomsInfo}
    />
  )
}

B13AFilingOption.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: b13AFilingOptionLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_B1A_FILING_OPTION_LABEL_PROPERTIES
    },
  },
]
